
export type ServerNetwork = {
  status: ServerNetworkStatus;
  isOnline: boolean;
}


export enum ServerNetworkStatus {
  'connected',
  'closed',
  'reconnecting'
}

export enum NetworkQuality {
  Poor = 1,
  Moderate = 2,
  Healthy = 3
}


